import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrorsAndJSON } from 'utils/handle-errors'
import { usersQueryKeys } from 'utils/query-keys'
import toast from 'react-hot-toast'
import { User } from 'interfaces/user'

export interface CreateUserParams {
  name?: string
  email?: string
  phone?: string
  organizationId?: string
  teamId?: string
  increaseSeatCount?: boolean
}

const createUser = async (params: CreateUserParams): Promise<User> => {
  let response = await fetch(`${BASE_API_URL}/admin/api/v1/users`, {
    method: API_METHODS.POST,
    headers: apiHeaders(store.getState()),
    body: JSON.stringify({
      name: params.name || '',
      email: params.email || '',
      phone_number: params.phone || '',
      ...(params.organizationId && { organization_id: params.organizationId }),
      ...(params.teamId && { team_id: params.teamId }),
      ...(params.increaseSeatCount !== undefined && {
        increase_seat_count: params.increaseSeatCount,
      }),
    }),
  })
  response = await handleErrorsAndJSON(response)
  const json = await response.json()
  return json.data.user
}

const useCreateUser = () => {
  const queryClient = useQueryClient()

  return useMutation((params: CreateUserParams) => createUser(params), {
    onSuccess: () => {
      toast('User created successfully', { icon: '👍' })
    },
    onError: (error: Error) => {
      console.error('Error creating user:', error?.message)
      toast(`Failed to create user. ${error?.message}`)
    },
    onSettled: () => {
      queryClient.invalidateQueries(usersQueryKeys.all)
    },
  })
}

export default useCreateUser
